@if (currentAppHasUpdateAvailable$ | async) {
  <div class="app-update-available-container p-4 w-full">
    <h6 class="mb-1 font-bold">
      {{ 'app-update-available.title' | translate }}
    </h6>
    <p class="opacity-70 mb-4 text-sm">
      {{ 'app-update-available.description' | translate }}
    </p>
    <div class="w-full flex justify-center">
      <rk-button
        variant="white"
        [isLoading]="unlockUpdateIsLoading$ | async"
        [text]="'app-update-available.cta' | translate"
        (buttonClick)="onCtaClick()"
        [fullWidth]="true"
      ></rk-button>
    </div>
  </div>
}
